import { useBucket } from '@mc/experiments-react'
import { CERTS_QUIZ_PLANS_FLAG, type ExperimentBucket } from '../constants'

export const useExperiment = () => {
  const bucket = useBucket<ExperimentBucket>(CERTS_QUIZ_PLANS_FLAG)

  return { isVariant: bucket === 'variant_1' }
}
